export default String.raw`
const CACHENAME =  'eShop-Cache-V1';
const DYNAMICCACHE = 'eShop-Dynamic-Cache-V1';
const FILELIST = ['css/offline.css', 'css/img/offline.jpg', './?offline=true'];

self.addEventListener('install', function(e){
    e.waitUntil(
        caches.open(CACHENAME).then(function(cache){
            return cache.addAll(FILELIST);
        })
    );
});

self.addEventListener('activate', function(e){
    e.waitUntil(
        caches.keys().then(function(keyList){
            return Promise.all(keyList.map(function(key){
                if(key !== CACHENAME){
                    return caches.delete(key);
                }
            }));
        })
    );
    return self.clients.claim();
});

self.addEventListener('fetch', function(e){
    if (e.request.method !== 'GET') {
        return;
    }
    e.respondWith(
        fetch(e.request).then(function(res){
            return caches.open(DYNAMICCACHE).then(function(cache){
                cache.put(e.request.url, res.clone());
                return res;
            })
        }).catch(function(){
            return caches.match(e.request).then(function(response){
                if(response){
                    return response;
                } else {
                    return caches.match('./?offline=true');
                }
            });
        })
    );
});
`